import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer
      data-testid="global-footer"
      className="w-full border-t border-border/60 bg-white/60 dark:bg-slate-900/60 backdrop-blur px-6 py-4 text-center text-sm text-slate-600 dark:text-slate-300"
    >
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 items-center justify-center flex-wrap">
        <div>
          {t("footer_text")}{" "}
          <span style={{ color: "#e63946" }} aria-label="heart">♥</span>{" "}
          in Düsseldorf {t("footer_by")}{" "}
          <a
            data-testid="footer-agency-link"
            href="https://beta-webagentur.de"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#2563eb",
              fontWeight: 700,
              textDecoration: "underline",
              padding: "2px 6px",
              backgroundColor: "rgba(37, 99, 235, 0.08)",
              borderRadius: "4px",
              transition: "background-color 0.2s ease-in-out, color 0.2s ease-in-out",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(37, 99, 235, 0.18)";
              e.currentTarget.style.color = "#1E40AF";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(37, 99, 235, 0.08)";
              e.currentTarget.style.color = "#2563eb";
            }}
          >
            Beta-Webagentur.de
          </a>
        </div>
        <div className="text-xs text-slate-400 hidden sm:inline">·</div>
        <nav className="flex gap-3 text-xs">
          <Link data-testid="footer-imprint" to="/legal/imprint" className="text-slate-500 hover:text-blue-700 hover:underline">Impressum</Link>
          <Link data-testid="footer-privacy" to="/legal/privacy" className="text-slate-500 hover:text-blue-700 hover:underline">Datenschutz</Link>
          <Link data-testid="footer-terms" to="/legal/terms" className="text-slate-500 hover:text-blue-700 hover:underline">AGB</Link>
        </nav>
      </div>
    </footer>
  );
}
